import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import type { TouchWeightAnalyzedKeyboard } from '@/lib/piano/touch-design/touch-weight-key-analysis';

/** A design is considered complete once most keys carry a down weight. */
export const DESIGN_COMPLETION_RATIO = 0.8;

/**
 * Whether the design resolves into a keyboard one can act on.
 *
 * The sidebar opens its last two pages on it, and the home page reads it to
 * know whether it can show the touch the reader is heading for; the two have
 * to agree, hence the one predicate.
 */
export const useIsDesignCompleted = designedKeyboard => {
  const $ = _c(2);
  let t0;
  if ($[0] !== designedKeyboard) {
    t0 = designedKeyboard.mapToArray(_temp).filter(_temp2);
    $[0] = designedKeyboard;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0.length >= Math.round(designedKeyboard.size * DESIGN_COMPLETION_RATIO);
};
function _temp(key) {
  return key.payload.downWeightWithoutSpringSupport;
}
function _temp2(weight) {
  return weight !== undefined && weight !== null;
}